
import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';


export const getDepartmentList = params => {
    return axios.get(`${BaseApiUrl}/ProductionReport/GetDepartment`, { params: params });
};

export function GetReceivingProductionOperationTypeList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetReceivingProductionOperationTypeList`, params);
}

export function GetReceivingProductionReport(params) {
    return axios.post(`${BaseApiUrl}/ProductionReport/GetReceivingProductionReport`, params);
}

export function ExportReceivingProductionReport(params) {
    return axios.post(`${BaseApiUrl}/ProductionReport/ExportReceivingProductionReport`, params);
}